module.exports = __webpack_public_path__ + "static/media/design2.a04c0a6e.svg";